import { createDynamicThunk } from ".";

export const getSettingListThunk = createDynamicThunk({
  typePrefix: "settings/getSettingListThunk",
  useHandleSearch: true,
});

export const addSettingThunk = createDynamicThunk({
  typePrefix: "settings/addSettingThunk",
  endpoint: "/settings",
  method: "POST",
  refreshList: true,
  listThunk: getSettingListThunk,
});

export const deleteSettingThunk = createDynamicThunk({
  typePrefix: "/deleteSettingThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getSettingListThunk,
});

export const getExpenseAnnualRestrictionThunk = createDynamicThunk({
  typePrefix: "expenseAnnualRestriction/getExpenseAnnualRestrictionThunk",
  endpoint: "/expense-annual-restriction/active",
  method: "POST",
  useHandleSearch: false,
});

export const enableExpenseAnnualRestrictionThunk = createDynamicThunk({
  typePrefix: "expenseAnnualRestriction/enableExpenseAnnualRestrictionThunk",
  endpoint: "/expense-annual-restriction/enable",
  method: "POST",
  refreshList: true,
  listThunk: getExpenseAnnualRestrictionThunk,
});

export const disableExpenseAnnualRestrictionThunk = createDynamicThunk({
  typePrefix: "expenseAnnualRestriction/disableExpenseAnnualRestrictionThunk",
  endpoint: "/expense-annual-restriction/disable",
  method: "POST",
  refreshList: true,
  listThunk: getExpenseAnnualRestrictionThunk,
});

export const updateExpenseAnnualRestrictionThunk = createDynamicThunk({
  typePrefix: "expenseAnnualRestriction/update",
  endpoint: (id) => `/expense-annual-restriction`,
  method: "PATCH",
  refreshList: true,
  listThunk: getExpenseAnnualRestrictionThunk,
});
